module.exports = __webpack_public_path__ + "fonts/KaTeX_SansSerif-Italic.b257a18.ttf";